import React, { useEffect, useState } from "react";
import { Button, Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./ProfilePage.scss";
import edit_profile from "../../../Assets/svg/edit_profile.svg";
import logout_icon from "../../../Assets/svg/logout_icon.svg";
import candleBg from "../../../Assets/images/candleBg.png";
import profileWrp from "../../../Assets/images/ProfileWrp.png";
import user from "../../../Assets/images/user.png";
import ProfileSec from "./component/Tabbed/Profile";
import PaymentHistorySec from "./component/Tabbed/PaymentHistory";
import TutorialSec from "./component/Tabbed/Tutorial";
import SettingTab from "./component/Tabbed/Setting";
import AboutTab from "./component/Tabbed/AboutTab";
import TermsConditionTab from "./component/Tabbed/TermsCondition";
import PrivacyPolicy from "./component/Tabbed/PrivacyPolicy";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/auth";
import { useFetchUserProfileQuery } from "store/services/user.service";
import { post } from "helpers/api_helper";
import toast from "react-hot-toast";
import Timezone from "./component/Tabbed/Timezone";
import FAQ from "./component/Tabbed/Faq";

const ProfilePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: userProfile, refetch } = useFetchUserProfileQuery(undefined);
  const [profileImage, setProfileImage] = useState(user);

  useEffect(() => {
    if (userProfile?.profileImage) {

      setProfileImage(userProfile.profileImage);
      refetch();
    }
  }, [userProfile]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await post("/user/upload", formData);
        if (response?.data?.path) {
          setProfileImage(response?.data?.path);
          toast.success("Image uploaded successfully!");
          refetch();
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        toast.error("Failed to upload image.");
      }
    }
  };

  return (
    <>
      <section
        className="profilePage position-relative"
        style={{
          backgroundImage: `url(${candleBg})`,
          backgroundSize: "cover",
          backgroundPosition: "top center",
          zIndex: 9,
        }}
      >
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div
                className="border rounded cardCstm p-3"
                style={{ background: "#ffffff9c" }}
              >
                <Row>
                  <Col lg="3" className="my-2">
                    <div className="ProfileView d-flex align-items-center justify-content-between flex-column h-100 border-end">
                      <div className="top w-100 py-3 text-center">
                        <div className="imgWrpper mx-auto position-relative">
                          <img src={profileWrp} alt="" className="img-fluid" />
                          <div className="inner position-absolute mx-auto">
                            <input
                              type="file"
                              className="file position-absolute h-100 w-100"
                              onChange={handleFileChange}
                            />
                            <img
                              src={profileImage}
                              alt=""
                              className="img-fluid rounded-circle"
                              height={84}
                              width={84}
                            />
                            <span className="icn position-absolute">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                              >
                                <circle cx="11" cy="11" r="11" fill="white" />
                                <path
                                  d="M14.9949 14.4766C15.2734 14.4766 15.5 14.7061 15.5 14.9883C15.5 15.271 15.2734 15.5 14.9949 15.5H12.1398C11.8613 15.5 11.6347 15.271 11.6347 14.9883C11.6347 14.7061 11.8613 14.4766 12.1398 14.4766H14.9949ZM13.0149 6.84953L13.7524 7.43539C14.0549 7.67189 14.2565 7.98363 14.3255 8.31149C14.405 8.67215 14.3202 9.02635 14.0814 9.33272L9.6882 15.014C9.48658 15.2719 9.18945 15.4171 8.87111 15.4224L7.1202 15.4439C7.02469 15.4439 6.94511 15.3794 6.92388 15.2881L6.52595 13.5627C6.45697 13.2456 6.52595 12.9178 6.72757 12.6651L9.84207 8.63399C9.89512 8.56949 9.99063 8.55928 10.0543 8.60711L11.3648 9.64984C11.4497 9.71971 11.5664 9.75733 11.6885 9.74121C11.9485 9.70896 12.1236 9.47247 12.097 9.21985C12.0811 9.09085 12.0174 8.98335 11.9325 8.90273C11.906 8.88123 10.6592 7.88151 10.6592 7.88151C10.5796 7.81701 10.5637 7.69876 10.6273 7.61867L11.1208 6.97853C11.5771 6.39267 12.3729 6.33892 13.0149 6.84953Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                        <div className="content pt-3">
                          <h4 className="m-0 fw-bold">{userProfile?.name}</h4>
                          <p className="m-0 py-1 text-muted">
                            {userProfile?.email}
                          </p>
                        </div>
                      </div>
                      <div className="bottom text-center w-100 py-3">
                        <Button
                          onClick={handleLogout}
                          className="d-inline-flex align-items-center justify-content-center rounded-pill logout p-2 pe-3"
                        >
                          <span className="icn me-2">
                            <img src={logout_icon} alt="" />
                          </span>
                          Log Out
                        </Button>
                      </div>
                    </div>
                  </Col>
                  <Col lg="9" className="my-2">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="Profile"
                      mountOnEnter
                    >
                      <Nav
                        variant="pills"
                        className="border-bottom gap-10 pb-2 justify-content-between underlineTab"
                      >
                        <Nav.Item className="px-2">
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="Profile"
                          >
                            Profile
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="PaymentHistory"
                          >
                            Payment History
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="Tutorial"
                          >
                            Tutorial
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="Setting"
                          >
                            Setting
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="Timezone"
                          >
                            Timezone
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="Faq"
                          >
                            FAQ
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="AboutUs"
                          >
                            About Us
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="TermsCondition"
                          >
                            Terms and Condition
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="position-relative px-0 pb-1 bg-transparent border-0 pt-0"
                            eventKey="PrivacyPolicy"
                          >
                            PrivacyPolicy
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content className="py-2">
                        <Tab.Pane eventKey="Profile">
                          <ProfileSec />
                        </Tab.Pane>
                        <Tab.Pane eventKey="PaymentHistory">
                          <PaymentHistorySec />
                        </Tab.Pane>
                        <Tab.Pane eventKey="Tutorial">
                          <TutorialSec />
                        </Tab.Pane>
                        <Tab.Pane eventKey="Setting">
                          <SettingTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="Timezone">
                          <Timezone />
                        </Tab.Pane>
                        <Tab.Pane eventKey="Faq">
                          <FAQ />
                        </Tab.Pane>
                        <Tab.Pane eventKey="AboutUs">
                          <AboutTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="TermsCondition">
                          <TermsConditionTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="PrivacyPolicy">
                          <PrivacyPolicy />
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ProfilePage;
